import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/Footer";
import { TrendingUp } from "lucide-react";

export const PageShell = ({ children }) => (
  <div className="min-h-screen bg-[#070A0E] text-white flex flex-col">
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#070A0E]/90 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="page-brand-home" className="flex items-center gap-2.5 group">
          <div className="h-9 w-9 rounded-md bg-brand/15 border border-brand/40 grid place-items-center group-hover:border-brand transition-colors">
            <TrendingUp className="h-5 w-5 text-brand" />
          </div>
          <div className="leading-none">
            <div className="font-heading font-extrabold tracking-tight text-[15px]">NETROY</div>
            <div className="font-data text-[9px] uppercase tracking-[0.25em] text-slate-500">Forex Academy</div>
          </div>
        </Link>
        <Link to="/" className="font-data text-xs uppercase tracking-widest text-slate-400 hover:text-brand">← Home</Link>
      </div>
    </header>
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
